/**
 * If user navigates directly this page somehow directly,
 * then send them home since they won't be able to complete login in this state.
 */
import { useEffect } from 'react'
import { baseUrl, targetEnv } from '@fs/zion-config'
import Cookies from 'js-cookie'

export default function useGoHomeIfNoSession() {
  useEffect(() => {
    // we can't get the session directly as it is http-only
    const noSession = !Cookies.get('XSRF-TOKEN')
    if (noSession && targetEnv && targetEnv !== 'local') {
      window.location.replace(baseUrl)
    }
  }, [])
}
